import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import APP from '../../modules';
// import APP from '../../modules';

export const homeView = (props) => {
  const {
    testDesignClick,
    showTestData,
    showTestBug,
    showTestDesign,
    testBugClick,
    testViewClick,
    testNewClick
  } = props;
  const email = localStorage.getItem('email');
  return (
    <div className='home__container'>
      <div className='container mt-4'>
        <div className='row d-flex justify-content-center'>
          <div className='col-md-6 px-3 py-3 mt-5 welcome-div'>
            <h2 className='text-center'>Welcome to XTForge</h2>
            <h6 className='mt-4 text-center'>What you would like to do</h6>
            {!showTestData && !showTestDesign && !showTestBug && (
              <div className='mt-4 col text-center'>
                <button
                  className='btn btn-color btn-width-200 mx-3 my-2'
                  onClick={() => testDesignClick('TestDesign')}
                >
                  Test Case Generation
                </button> 
              </div>
            )}
            {showTestDesign && (
              <>
                <div className='mt-4 col text-center'>
                  <button
                    className='btn btn-color btn-width-200 mx-3 my-2'
                    onClick={() => testNewClick('TestDesign')}
                  >
                    Create New Test
                  </button>
                </div>
                <div className='mt-2 col text-center'>
                  <button
                    className='btn btn-color btn-width-200 mx-3'
                    onClick={() => testViewClick('TestDesign')}
                  >
                    View Existing Test
                  </button>
                </div>
              </>
            )}
            {!showTestData && !showTestDesign && !showTestBug && (
              <div className='mt-3 col text-center'>
                {/* <Link to={APP.Constants.ROUTES.BUG_CREATION}> */}
                  <button
                    className='mx-2 btn btn-width-200 btn-color'
                    onClick={() => testDesignClick('BugCreation')}
                  >
                    Bug Creation
                  </button>
                {/* </Link> */}
              </div>
            )}
            {showTestBug && (
              <>
                <div className='mt-4 col text-center'>
                  <button
                    className='btn btn-color btn-width-250 mx-3 my-2'
                    onClick={() => testBugClick('linkedBug')}
                    title='Use AI to generate and file a detailed bug directly under the selected User Story.'
                  >
                    AI-Create Bug (Linked to Story)
                  </button>
                </div>
                <div className='mt-3 col text-center'>
                  <button
                    className='btn btn-color btn-width-250 mx-3'
                    onClick={() => testBugClick('standaloneBug')}
                    title='Use AI to create a new, fully detailed bug without linking to any User Story.'
                  >
                    AI-Create Standalone Bug
                  </button>
                </div>
                {/* <div className='mt-3 col text-center'>
                  <button
                    className='btn btn-color btn-width-250 mx-3'
                    // onClick={() => testBugClick('enhanceBug')}
                    title='Refine an existing bug’s title, description, and repro steps using GenAI.'
                  >
                    AI-Enhance Existing Bug
                  </button>
                </div> */}
              </>
            )}
            {!showTestData && !showTestDesign && !showTestBug && (
              <div className='mt-3 col text-center'>
                <button
                  className='mx-2 btn btn-width-200 btn-color'
                  onClick={() => testDesignClick('TestData')}
                >
                  Test Data Generation
                </button>
              </div>
            )}
            {showTestData && (
              <>
                <div className='mt-4 col text-center'>
                  <button
                    className='mx-2 my-2 btn btn-width-200 btn-color'
                    onClick={() => testNewClick('TestData')}
                  >
                    Create Test Data
                  </button>
                </div>
                <div className='mt-2 col text-center'>
                  <button
                    className='mx-2 btn btn-width-200 btn-color'
                    onClick={() => testViewClick('TestData')}
                  >
                    View Test Data
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
